import { render, staticRenderFns } from "./Rechtssammlung.vue?vue&type=template&id=2b5d9c84&"
import script from "./Rechtssammlung.vue?vue&type=script&lang=js&"
export * from "./Rechtssammlung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports